import React from "react";
import { Zap } from "lucide-react";
import AssetFamilyPanel from "../components/AssetFamilyPanel";
import { FIVE_STATE_STATUS_VALUES } from "../components/StatusSelectField";
import { createHook, createHookVersion, getHooks, updateHookMetadata } from "../../../lib/emailMarketingApi";

// EMAILS-IMPL-009: Hooks authoring (HOK-SPEC-001). Multiline editor, per
// checkpoint §10.
const config = {
  familyCode: "HOK",
  testIdPrefix: "hooks",
  idField: "hook_id",
  contentField: "canonical_hook",
  contentLabel: "Canonical Hook",
  contentInputType: "textarea",
  contentPlaceholder: "e.g. Most families find out too late they're underinsured.",
  labelSingular: "Hook",
  labelPlural: "Hooks",
  icon: Zap,
  statusValues: FIVE_STATE_STATUS_VALUES,
  createDescription: "A governed, reusable opening hook (HOK####).",
  api: {
    list: getHooks,
    create: ({ name, status, content }) => createHook({ name, status, canonicalHook: content }),
    createVersion: (id, { version, content }) => createHookVersion(id, { version, canonicalHook: content }),
    updateMetadata: (id, { name, status }) => updateHookMetadata(id, { name, status }),
  },
};

export default function HooksPanel() {
  return <AssetFamilyPanel config={config} />;
}
